<template>
  <component :is="layoutComponent" v-bind="layoutProps">
    <template slot="field">
      <div v-if="field.route" class="text-center">
        <button type="button" class="btn btn-primary btn-lg" @click="$router.push('/'+field.route)">
          <i class="icon-google mr-2"></i>
          {{ field.label }}
        </button>
        <p v-if="field.afterText" style="margin-top: 15px">{{ field.afterText }}</p>
      </div>
    </template>
  </component>
</template>

<script>
import { FormTextField } from 'stylemix-base'

export default {
  name: 'ButtonField',
  extends: FormTextField,

  mounted () {

  }
}
</script>

